import { RepeatIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Spinner,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tooltip,
  useBreakpointValue,
  VStack,
  Text,
  Grid,
  Button,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import {
  Suspense,
  lazy,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import CustomSelect from "../common/CustomSelect/CustomSelect";
import useFindBuyerName from "../constants/function";
import { useHasPermission } from "../common/PermissionsFunction/permissiosnFunction";
import { initialDateRange } from "./OrderDashboard/function/constant";
import { HiOutlineFilter, HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import { FaFilter } from "react-icons/fa6";

const OrderDashboard = lazy(() => import("./OrderDashboard/OrderDashboard"));
const ReconciliationDashboard = lazy(
  () => import("./ReconciliationDashboard/ReconciliationDashboard")
);
const IssueDashboard = lazy(() => import("./IssueDashboard/IssueDashboard"));

export default function MainDashboard() {
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState<any>([]);
  const [providers, setProviders] = useState<any>([]);
  const [cityFilter, setCityFilter] = useState<any>("");
  const [cityCode, setCityCode] = useState<any>("");
  const [cityName, setCityName] = useState<any>("");
  const [providerFilter, setProviderFilter] = useState<any>("");
  const [providerId, setProviderId] = useState<any>("");

  const [refresh, setRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState<number>(0);
  // const { bapIds } = useContext(AppContext);

  const getCities = async (currentP?: number) => {
    try {
      setLoading(true);
      const response: any = await appRequest("metro", "allCities", {});

      if (response.status === "success") {
        // setTotalPages(response?.totalPages || 0);
        setCities(response?.cities || []);
        console.log("get cities response", cities);
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getProviders = async () => {
    try {
      const id = cityFilter;
      const response: any = await appRequest("metro", "allProvidersForFilter", {
        id,
        cityCode
      });

      if (response.status === "success") {
        setProviders(response.allProviders || []);
      }
    } catch (error: any) {
      console.error("Error fetching providers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedCity = JSON.parse(
      localStorage.getItem("selectedCity") || "null"
    ); // Parse directly and handle null
    console.log("what in local storage->", localStorage.getItem("selectedCity"))
    if (storedCity) {
      setCityFilter(storedCity.id); // Set the city ID
      setCityCode(storedCity.cityCode)
      setCityName(storedCity.name); // Set city Name
      console.log("Stored city data:", storedCity); // Optional: Debugging log
    } else {
      setCityFilter(null); // Or set a default value
    }
  }, []);

  useEffect(() => {
    getCities();
  }, [activeTab, refresh]);

  useEffect(() => {
    getProviders();
  }, [cityFilter]);

  // Handle the start date change
  const selectWidth = useBreakpointValue({ base: "100%", md: 220 });

  const [dateRange, setDateRange] = useState<any>(initialDateRange);

  const handleStartDateChange = (startDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      startDate: new Date(startDate),
    }));
  };

  const handleEndDateChange = (endDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      endDate: new Date(endDate),
    }));
  };

  const handleDateChange = (item: any) => {
    const newStartDate = item.selection.startDate.toISOString();
    const newEndDate = item.selection.endDate.toISOString();
    handleStartDateChange(newStartDate);
    handleEndDateChange(newEndDate);
  };

  // const handleFilterChange = (e: any) => {
  //   setBapIdFilter(e.value);
  // };

  const handleCityFilterChange = (e: any) => {
    if (e && e.value) {
      const selectedCity = {
        id: e.value, // city ID
        cityCode: e.cityCode, // city code
        name: e.label, //  city name
      };
      setCityFilter(selectedCity.id);
      setCityCode(selectedCity.cityCode);
      setCityName(selectedCity.name);
      localStorage.setItem("selectedCity", JSON.stringify(selectedCity));
      getProviders();
    } else {
      setCityFilter(null); // or any default value you'd like to set
      localStorage.removeItem("selectedCity");
    }
  };

  const handleProvierFilterChange = (e: any) => {
    if (e && e.value) {
      setProviderFilter(e.value);

      // Find the selected provider by its name (which is stored in e.value)
      const selectedProvider = providers.find(
        (provider: any) => provider.providerName === e.value
      );

      // Set the selected provider's bpp_id if found
      if (selectedProvider) {
        setProviderId(selectedProvider.bpp_id);
      } else {
        setProviderId(""); // Fallback if not found
      }

    } else {
      setProviderFilter(null); // or any default value you'd like to set

    }
  };

  // Handle tab change
  const handleTabChange = useCallback((index: number) => {
    setActiveTab(index);
  }, []);

  // const findProviderNameByBapId = useFindBuyerName();
  const cityNames = cities.map((city: any) => ({
    value: city?._id,
    label: city?.name,
    cityCode: city?.cityCode,
  }));

  const providerNames = providers.map((provider: any) => ({
    value: provider?.providerName,
    label: provider?.providerName,
  }));






  return (
    <Box>
      <Tabs colorScheme="teal" onChange={handleTabChange}>
        <Flex
          justify={"space-between"}
          direction={{ base: "column", lg: "row" }}
        >
          <TabList gap={3}>
            {/* SHOULD ADD PERMISION LATER ON */}
            {/* {useHasPermission("canViewOrderDashboard") && (
              <Tab fontWeight={500}>Order</Tab>
            )}
            {useHasPermission("canViewReconciliationDashboard") && (
              <Tab fontWeight={500}>Reconciliation</Tab>
            )}
            {useHasPermission("canViewIssueDashboard") && (
              <Tab fontWeight={500}>Issues</Tab>
            )} */}

            {/* )}  */}
          </TabList>

          <Flex
            gap={{ base: 1, md: 2 }}
            pr={{ base: 0, lg: 4 }}
            mt={{ base: 2, lg: 0 }}
            justify={"end"}
            direction={{ base: "column", md: "row" }}
          >
            <Flex align="center" gap={2} mb={{ base: 2, lg: 0 }}>
              {cityFilter ? (
                <Text fontWeight="bold" fontSize="md" color="teal.600">
                  City:{cityName}
                </Text>
              ) : (
                <Text fontWeight="bold" fontSize="md" color="gray.500">
                  No City Selected
                </Text>
              )}
            </Flex>

            <Box display={{ base: "none", lg: "block" }}>
              <CustomDateRangePicker
                dateFrom={dateRange.startDate && new Date(dateRange.startDate)}
                dateTo={dateRange.endDate && new Date(dateRange.endDate)}
                onStartDateChange={handleStartDateChange}
                onEndDateChange={handleEndDateChange}
                months={2}
              />
            </Box>
            <Box display={{ base: "block", lg: "none" }}>
              <CustomDateRangeMobile
                range={[dateRange]}
                onChange={handleDateChange}
              />
            </Box>
            <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
              <Popover>
                <PopoverTrigger>
                  <IconButton
                    aria-label="Filter"
                    colorScheme="teal"
                    bg="teal.300"
                    icon={<FaFilter fontSize="0.8rem" />}
                    size={{ base: "sm", md: "md" }}
                  />
                </PopoverTrigger>
                {/* <Portal> */}
                <PopoverContent shadow={"lg"} borderWidth={2} w={"fit-content"} mr={2}>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody p={5}>
                    <VStack spacing={6} mt={2}>
                      <CustomSelect
                        options={cityNames}
                        label={"Filter By City"}
                        onChange={handleCityFilterChange}
                        width={selectWidth}
                      />
                      {/* <CustomSelect
                        options={providerNames}
                        label={"Filter by Providers"}
                        onChange={handleProvierFilterChange}
                        width={selectWidth}
                      /> */}
                    </VStack>
                  </PopoverBody>
                </PopoverContent>
                {/* </Portal> */}
              </Popover>
              {/* <Flex gap={2} align={"center"} mt={{ base: 2, md: "unset" }}> */}
              {/* <CustomSelect
                options={bapNames}
                label={"Buyer App"}
                onChange={handleProvierFilterChange}
                width={selectWidth}
              /> */}

              {/* <Tooltip label="Refresh" hasArrow placement="top">
                <IconButton
                  aria-label="Reset"
                  icon={<RepeatIcon />}
                  colorScheme="teal"
                  size={{ base: "sm", md: "md" }}
                  variant={"outline"}
                  onClick={() => {
                    setDateRange(initialDateRange);
                    setRefresh(!refresh);
                    setProviderFilter("");
                  }}
                />
              </Tooltip> */}
              <Box>
                <Tooltip hasArrow textAlign={"center"} label="Reset" placement="bottom">
                  <Button
                    border="2px solid"
                    borderColor="teal.300"
                    w={{ base: "3rem", lg: "auto" }}
                    bg="white"
                    // fontSize="sm"
                    color="teal.400"
                    _hover={{ bg: "teal.300", color: "white" }}
                    onClick={() => {
                      setDateRange(initialDateRange);
                      setRefresh(!refresh);
                      setProviderFilter("");
                    }}
                  >
                    <HiOutlineRefresh fontSize="1.2rem" />
                  </Button>
                </Tooltip>
              </Box>
              {/* </Flex> */}
            </Grid>
          </Flex>
        </Flex>
        <TabIndicator
          mt="-1.5px"
          height="3px"
          bg="teal.500"
          borderRadius="2px"
          display={{ base: "none", lg: "block" }}
        />

        <TabPanels>
          {/* SHOULD UPDATE WITH PERMISSIONS */}
          {useHasPermission("canViewOrderDashboard") && (
            <TabPanel px={{ base: 0, lg: 4 }} pt={{ base: 4, lg: 6 }}>
              <Suspense fallback={<CommonSpinner />}>
                {activeTab === 0 && (
                  <OrderDashboard
                    refresh={refresh}
                    dateRange={dateRange}
                    providerFilter={providerFilter}
                    cityFilter={cityFilter}
                    cityCode={cityCode}
                    isCitySelected={cityFilter ? true : false}
                  />
                )}
              </Suspense>
            </TabPanel>
          )}

          {useHasPermission("canViewReconciliationDashboard") && (
            <TabPanel px={{ base: 0, lg: 4 }}>
              <Suspense fallback={<CommonSpinner />}>
                {activeTab === 1 && (
                  <ReconciliationDashboard
                    refresh={refresh}
                    dateRange={dateRange}
                    providerFilter={providerFilter}
                    isCitySelected={cityFilter ? true : false}
                    cityCode={cityCode}
                    providerId={providerId}
                  />
                )}
              </Suspense>
            </TabPanel>
          )}
          {useHasPermission("canViewIssueDashboard") && (
            <TabPanel px={{ base: 0, lg: 4 }}>
              <Suspense fallback={<CommonSpinner />}>
                {activeTab === 2 && (
                  <IssueDashboard
                    dateRange={dateRange}
                    providerFilter={providerFilter}
                    refresh={refresh}
                    cityCode={cityCode}
                    isCitySelected={cityFilter ? true : false}
                  />
                )}
              </Suspense>
            </TabPanel>
          )}

          {/* )} */}
        </TabPanels>
      </Tabs>
    </Box>
  );
}

const CommonSpinner = () => {
  return (
    <Flex justify={"center"} mt={6}>
      <Spinner color="teal.500" size="xl" thickness="4px" />
    </Flex>
  );
};
